<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <button
        class="auth_back"
        type="button"
        @click="$router.back()"
      >
        <span class="back_left" />
      </button>
      <div
        class="auth_brand"
        aria-hidden="true"
      >
        <span />
        <span />
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/shop2/lang.png')">
      </div>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/top.jpg"
      >
    </div>
    <div class="form">
      <h1 class="auth_title">
        {{ $t('login.login') }}
      </h1>
      <div class="item">
        <span class="icon">
          <van-icon
            name="contact"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.username"
          type="text"
          class="inp"
          :placeholder="$t('login.phoneNumber')"
        >
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('login.password')"
        >
        <div
          class="eye_bi"
          :class="password === 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item_reset_pwd">
        <van-checkbox
          v-model="checked"
          icon-size="14px"
        >
          {{ $t('login.remember') }}
        </van-checkbox>
        <!-- <router-link
          class="reset_pwd"
          to="/forgetpwd"
        >
          {{ $t('login.forget') }}
        </router-link> -->
      </div>
      <div
        type="submit"
        class="basic_btn sbtn"
        :class="data.username === '' || data.password === '' ? 'no_touch' : ''"
        @click="submit"
      >
        {{ $t('login.login') }}
      </div>
      <div class="register">
        {{ $t('login.signUp') }}
        <router-link
          class="link"
          to="/register"
        >
          {{ $t('register.register') }}
        </router-link>
      </div>
    </div>
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from '../../utils/fetch'
import { Checkbox, Icon } from 'vant'

Vue.use(Checkbox).use(Icon)

export default {
  name: 'Login',
  data() {
    return {
      lang: this.$i18n.locale || 'zh_cn',
      password: 'password',
      show_kefu: true,
      msg_show: true,
      checked: true,
      app: null,
      data: {
        username: '',
        password: '',
      },
    }
  },
  created() {
    this.data.username = localStorage.getItem('login_username')
    this.data.password = localStorage.getItem('login_password')
    this.$parent.footer('user', false)
  },
  mounted() {
    document.body.addEventListener('scroll', this.handleBodyScroll, false)
    document.addEventListener('click', this.handleDocumentClick, false)
    Fetch('/index/webconfig').then((res) => {
      this.app = res.data
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.handleBodyScroll, false)
    document.removeEventListener('click', this.handleDocumentClick, false)
  },
  methods: {
    handleBodyScroll() {
      if (!this.show_kefu) {
        return
      }
      this.show_kefu = false
    },
    handleDocumentClick(event) {
      if (event.target.className !== 'kefu_img') {
        this.show_kefu = false
      }
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push('/kefu2')
      }
      this.show_kefu = !this.show_kefu
    },
    showPwd() {
      this.password = this.password === 'password' ? 'text' : 'password'
    },
    submit() {
      if (!this.data.username) {
        this.$toast(this.$t('login.phoneEmpty'))
        return
      }

      if (!this.data.password) {
        this.$toast(this.$t('login.passwordEmpty'))
        return
      }

      if (this.checked) {
        localStorage.setItem('login_username', this.data.username)
        localStorage.setItem('login_password', this.data.password)
      }

      if (!this.checked) {
        localStorage.removeItem('login_username')
        localStorage.removeItem('login_password')
      }

      Fetch('/index/login', {
        username: this.data.username,
        password: this.data.password,
      })
        .then((res) => {
          if (res.data.token) {
            localStorage.setItem('token', res.data.token)
          }
          this.$toast({
            background: '#07c160',
            message: this.$t('login.signInSuccess'),
          })
        })
        .then(() => {
          this.$router.replace({
            path: 'user',
          })
        })
    },
  },
}
</script>

<style lang="less" scoped>
.login_bg {
  position: relative;
  width: 100%;
  height: 48px;
  overflow: hidden;
}

.language {
  position: absolute;
  top: 4px;
  right: 0;
  height: 36px;
}

.language img {
  display: block;
  height: 100%;
}

.basic_wrap .form {
  box-sizing: border-box;
  width: 94%;
  height: 332px;
  margin: 0 auto;
  padding: 0 8%;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 4px 9px 2px rgba(160, 160, 160, 0.15);
  -webkit-animation: bot_top-data 0.3s;
  animation: bot_top-data 0.3s;
}

.login_logo {
  width: 100%;
  color: #fff;
  text-align: center;
  -webkit-animation: bot_top-data 0.3s;
  animation: bot_top-data 0.3s;
}

.login_logo img {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
  -webkit-animation: logobig-data 0.5s;
  animation: logobig-data 0.5s;
}

.item {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  height: 68px;
  padding-bottom: 4px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
}

.item .icon {
  width: 32px;
  height: 27px;
}

.item input {
  height: 20px;
  flex: 1;
  min-width: 0;
  margin-bottom: 3px;
  margin-left: 7px;
  border: 0;
  outline: 0;
  color: #000;
  font-size: 14px;
  background: transparent;
}

.item input::placeholder {
  color: #000;
  font-weight: 700;
}

.item_reset_pwd {
  margin-top: 10px;
  color: #323233;
  font-size: 14px;
  line-height: 20px;
}

.van-checkbox {
  margin-top: 20px;
}

.reset_pwd {
  display: block;
  margin-top: -20px;
  color: #323233;
  text-align: right;
}

.basic_btn {
  height: 45px;
  margin: 39px auto 0;
  border: 0;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  line-height: 45px;
  text-align: center;
  background: linear-gradient(90deg, #ff2d5b, #c71964);
  box-shadow: 0 9px 14px rgba(176, 32, 90, 0.25);
}

.register {
  margin-top: 30px;
  color: #000;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.register .link {
  margin-left: 5px;
  color: #5727a3;
}

.basic_wrap {
  display: inline-block;
  width: 100%;
  min-height: 100vh;
  max-width: 750px;
  padding-bottom: 10%;
  background: #fff url('../images/shop2/1.png') no-repeat center top;
  background-size: cover;
}

/deep/ .van-checkbox__label {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

/deep/ .van-checkbox__icon--checked .van-icon {
  border-color: #f32d5b;
  background-color: #f32d5b;
}

@-webkit-keyframes bot_top-data {
  0% {
    margin-top: 1000px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
}

@keyframes bot_top-data {
  0% {
    margin-top: 1000px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
}

@-webkit-keyframes logobig-data {
  0% {
    -webkit-transform: scale(0.3);
    opacity: 0;
  }
  50% {
    -webkit-transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
}

@keyframes logobig-data {
  0% {
    -webkit-transform: scale(0.3);
    opacity: 0;
  }
  50% {
    -webkit-transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
}

/* Airbnb-inspired authentication visual system */
.basic_wrap {
  position: relative;
  flex: 0 0 auto;
  min-height: 100vh;
  overflow: visible;
  background: #f7f7f7;
}

.basic_wrap::before {
  position: absolute;
  inset: 0;
  content: '';
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 255, 255, 0.78) 100%),
    url('../images/shop2/1.png') no-repeat center / cover;
  pointer-events: none;
}

.login_bg,
.form {
  position: relative;
  z-index: 1;
}

.login_bg {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  overflow: visible;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(34, 34, 34, 0.08);
}

.auth_back {
  position: absolute;
  top: 0;
  left: 10px;
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0;
  border: 0;
  background: transparent;
}

.auth_back .back_left {
  width: 22px;
  height: 22px;
  margin: 0;
}

.auth_brand {
  position: relative;
  width: 34px;
  height: 34px;
}

.auth_brand span {
  position: absolute;
  top: 4px;
  width: 17px;
  height: 27px;
  border: 3px solid #ff385c;
  border-radius: 15px 15px 14px 14px;
  transform: rotate(-33deg);
}

.auth_brand span:first-child {
  left: 6px;
}

.auth_brand span:last-child {
  right: 6px;
  transform: rotate(33deg);
}

.language {
  top: 7px;
  right: 18px;
  width: 36px;
  height: 36px;
}

.language img {
  width: 100%;
  height: 100%;
}

.login_logo {
  display: none;
}

.basic_wrap .form {
  box-sizing: border-box;
  width: calc(100% - 20px);
  height: auto;
  min-height: 0;
  margin: 38px auto 32px;
  padding: 30px 22px 28px;
  border: 1px solid rgba(34, 34, 34, 0.08);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  -webkit-animation: none;
  animation: none;
}

.auth_title {
  margin: 0 0 24px;
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
}

.item {
  box-sizing: border-box;
  align-items: center;
  height: 58px;
  margin-top: 12px;
  padding: 0 14px;
  border: 1px solid #b0b0b0;
  border-radius: 12px;
  background: #fff;
}

.item:first-of-type {
  margin-top: 0;
}

.item .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 100%;
  color: #222;
}

.item input {
  height: 100%;
  margin: 0 0 0 10px;
  color: #222;
  font-size: 15px;
  font-weight: 400;
}

.item input::placeholder {
  color: #717171;
  font-weight: 400;
}

.eye_bi {
  width: 20px;
  height: 24px;
}

.item_reset_pwd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  color: #222;
  font-size: 14px;
}

.van-checkbox {
  margin-top: 0;
}

.reset_pwd {
  display: inline;
  margin: 0;
  color: #222;
  font-weight: 500;
  line-height: 20px;
  text-decoration: underline;
}

.form .basic_btn {
  width: 100%;
  height: 50px;
  margin: 28px 0 0;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 50px;
  background: #ff385c;
  box-shadow: none;
}

.form .basic_btn.no_touch {
  color: #fff;
  opacity: 0.5;
}

.register {
  margin-top: 24px;
  color: #222;
  font-size: 14px;
  line-height: 20px;
}

.register .link {
  color: #222;
  font-weight: 600;
  text-decoration: underline;
}

/deep/ .van-checkbox__label {
  color: #222;
  font-size: 14px;
  font-weight: 400;
}

/deep/ .van-checkbox__icon--checked .van-icon {
  border-color: #ff385c;
  background-color: #ff385c;
}

.kefu {
  width: 50px;
  height: 50px;
}

.login_logo {
  position: relative;
  z-index: 1;
  display: block;
  width: calc(100% - 20px);
  margin: 6px auto 0;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);
  -webkit-animation: bot_top-data 0.3s;
  animation: bot_top-data 0.3s;
}

.login_logo img {
  display: block;
  width: 100%;
  margin: 0;
  border-radius: 0;
  -webkit-animation: logobig-data 0.5s;
  animation: logobig-data 0.5s;
}

.basic_wrap .form {
  margin-top: 18px;
}
</style>
